<template>
  <main class="login-content">
    <slot />
  </main>
</template>

<script lang="ts" setup>

</script>

<style>
.login-content {
  display: flex;
  justify-content: center; 
  align-items: center; 
  height: 100vh;
  width: 100vw;
  background-image: url('/images/background_login2.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
</style>